import { Component, ViewEncapsulation } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal, NgbDropdown, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastNotificationService } from '../core/toast-notification.service';
import { UIBlockingService } from '../core/ui-blocking.service';
import { DumbMemberDiscount } from '../public-portal/member-information/DTOs/dumb-member-discount';
import { SuperAdminMemberManagementService } from './super-admin-member-management.service';
import { DatePipe } from '@angular/common';
import { AddEditChamberPerkRequest } from './DTOs/add-edit-chamber-perk-request';

@Component({
  selector: 'app-add-edit-chamber-perk-modal',
  templateUrl: './add-edit-chamber-perk-modal.component.html',
  providers: [UIBlockingService, NgbDropdown],
  encapsulation: ViewEncapsulation.None
})
export class AddEditChamberPerkModalComponent {
  constructor(private superAdminMemberManagementService: SuperAdminMemberManagementService
    , private blockUI: UIBlockingService
    , private notificationService: ToastNotificationService
    , private activeModal: NgbActiveModal) {

  }
  now = new Date()
  valueCtrl = new FormControl("value", [Validators.required]);
  limitCtrl = new FormControl("limit");
  startDateCtrl = new FormControl("startDate");
  endDateCtrl = new FormControl("endDate");

  perkForm: FormGroup = new FormGroup({
    value: this.valueCtrl,
    limit: this.limitCtrl,
    startDate: this.startDateCtrl,
    endDate: this.endDateCtrl
  });
  perk: DumbMemberDiscount;
  headerText: string;
  adding: any;
  validationTriggered = false;
  isBusy = false;
  isMemberAdmin = false;
  hideStatusToggle = false;

  value() { return this.perkForm.get('value').value }
  limit() { return this.perkForm.get('limit').value }
  startDate() { return this.perkForm.get('startDate').value }
  endDate() { return this.perkForm.get('endDate').value }

  ngOnInit() {
    this.resetManageAdminForm();
  }

  private resetManageAdminForm(): void {
    this.perkForm.reset();
    if (this.adding) {
      this.perkForm.patchValue({
        value: '',
        limit: null,
        startDate: null,
        endDate: null
      });
    }
    else {
      this.perkForm.patchValue({
        value: this.perk.value,
        limit: this.perk.limit,
        startDate: this.perk.validFrom,
        endDate: this.perk.validThrough
      });
    }

  }
  save() {
    for (var i in this.perkForm.controls) {
      this.perkForm.controls[i].markAsTouched();
    }
    if (!this.perkForm.valid) {
      return false;
    }

    this.blockUI.start();

    if (this.adding) {
      var request = new AddEditChamberPerkRequest(
        this.value()
        , this.endDate()
        , this.startDate()
        , this.limit()
      );
      this.superAdminMemberManagementService.addChamberPerk(request)
        .subscribe({
          next: (data) => {
            console.log('Observable emitted the next value: ' + data);
          },
          error: (err) => {
            console.error('Observable emitted an error: ' + err);
            this.blockUI.stop();
          },
          complete: () => {
            console.log('Observable emitted the complete notification');
            this.blockUI.stop();
            this.activeModal.close();
          }
        });
    }
    else{
      if (this.adding) {
        var request = new AddEditChamberPerkRequest(
          this.value()
          , this.endDate()
          , this.startDate()
          , this.limit()
        );

        this.superAdminMemberManagementService.addChamberPerk(request)
          .subscribe({
            next: (data) => {
              console.log('Observable emitted the next value: ' + data);
            },
            error: (err) => {
              console.error('Observable emitted an error: ' + err);
              this.blockUI.stop();
            },
            complete: () => {
              console.log('Observable emitted the complete notification');
              this.blockUI.stop();
              this.activeModal.close();
            }
          });
      }
      else{
        var request = new AddEditChamberPerkRequest(
          this.value()
          , this.endDate()
          , this.startDate()
          , this.limit()
        );
        request.perkId = this.perk.discountId;

        this.superAdminMemberManagementService.editChamberPerk(request)
          .subscribe({
            next: (data) => {
              this.perk = data;
              console.log('Observable emitted the next value: ' + data);
            },
            error: (err) => {
              console.error('Observable emitted an error: ' + err);
              this.blockUI.stop();
            },
            complete: () => {
              console.log('Observable emitted the complete notification');
              this.blockUI.stop();
              this.activeModal.close(this.perk);
            }
          });
      }
    }
    return true;
  }
  dismiss(): void {
    this.activeModal.dismiss();
  }

}
